import { useRef, useState } from "react";
import { FileUp } from "lucide-react";
import { cn } from "@/lib/utils";

export function DropZone({ accept, multiple = false, onFiles, title, hint, testId = "drop-zone", disabled }) {
  const input = useRef(null);
  const [over, setOver] = useState(false);
  const pick = (list) => { const files = Array.from(list || []); if (files.length) onFiles(multiple ? files : [files[0]]); };
  return (
    <div role="button" tabIndex={0} aria-disabled={disabled} data-testid={testId}
      onClick={() => !disabled && input.current?.click()} onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && !disabled && input.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); if (!disabled) pick(e.dataTransfer.files); }}
      className={cn("flex cursor-pointer flex-col items-center justify-center gap-3 rounded-[6px] border-2 border-dashed px-6 py-10 text-center transition-colors duration-200",
        over ? "border-brand bg-brand-tint" : "border-line bg-subtle/60 hover:border-brand/50 hover:bg-brand-tint/40", disabled && "pointer-events-none opacity-60")}>
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-brand shadow-sm"><FileUp size={22} aria-hidden="true" /></span>
      <p className="text-sm font-medium text-ink">{title}</p>
      <p className="text-xs text-ink-secondary">{hint}</p>
      <input ref={input} type="file" accept={accept} multiple={multiple} className="hidden" data-testid={`${testId}-input`}
        onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
    </div>
  );
}
